import React, { useState, useEffect, Fragment, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ProductLicenses } from "../../components/ProductDetails";

//styles
//import "./styles.css";
//import "./stepper.css";
import "../../ui-styles/payment/payment.css";
// components
import Controls from "../../ui-styles/controls/controls";
// import FullPageLoader from "../fullPageLoader";
import { createOrder, capturePayment, applyCoupon, createFreeOrder, getCouponDetails } from "../../actions/license";
// import config from "../../config.json";
// import { createUser } from "../../actions/users";
// import { updatePaymentStatus } from "../../actions/users";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { PayLoadCtx } from "../../lib/context";
// import Loading from "../../components/loading";
// import { getUnlicencedData } from "../../actions/users";
import { getAxios } from "../../actions/appointment";
import { getSubdomain } from "../../lib/domain";
// const psl = require('psl');


function PlaceYourOrder(props) {
    const pathParams = useParams();
    const searchParams = new URLSearchParams(window.location.search);
    // const username = searchParams.get('username');
    // const subdomain = searchParams.get('subdomain');
    const [clinicBody, setClinicBody] = useState({});

    // let productPathCode = props?.location?.search.includes("productCode=INVCFREE") ? "INVCFREE" : props?.location?.state?.productCode;
    let productPathCode = pathParams?.productCode === "INVCFREE" ? "INVCFREE" : pathParams.productCode;
    const history = useHistory();
    // const { cId, l, role, userId } = props;
    // const [errorMsg, setErrorMsg] = useState(null);
    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);

    const { payload } = useContext(PayLoadCtx);
    // const [active, setActive] = useState(false);
    const [licenseCount, setLicenseCount] = useState(5);
    const [product, setProduct] = useState(null);
    // const productCode = productPathCode;
    // const [productCode, setProductCode] = useState();
    const [loading, setLoading] = useState(false);
    const [order, setOrder] = useState(null);
    // const clinicBody = props && props.location && props.location.state && props.location.state.clinic_body;
    const [openCoupon, setOpenCoupon] = useState(false);
    const [discount, setDiscount] = useState(null);
    const [couponError, setCouponError] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [maxCurr, setMaxCurr] = useState();

    // const [renewal, setRenewal] = useState(null);
    // const [days, setDays] = useState(0);

    // const validSubDomain = !(window.location.hostname !== "localhost" && _domain && _domain.subdomain && _domain.subdomain !== process.env.REACT_APP_defaultdomian);

    // if (validSubDomain && !clinicBody) {
    //     console.log(window.location.pathname);
    //     console.log(props.match.params.docs);

    //     if (!isNaN(props.match.params.docs)) {
    //         history.push({
    //             pathname: "/clinic-signup",

    //             state: { docnum: props.match.params.docs },
    //         });
    //     } else {
    //         history.push("/");
    //     }
    // }


    // useEffect(() => {
    //     const script = document.createElement('script');

    //     script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    //     script.dataset.payment_button_id = "pl_I2rqlYgYBCvste";
    //     script.dataset.button_theme = "brand-color";
    //     script.async = true;

    //     // const _form = document.createElement('form');

    //     // _form.appendChild(script);
    //     document.getElementById('abc').appendChild(script);

    //     return () => {
    //         document.getElementById('abc').removeChild(script);
    //     }
    //   }, []);

    // useEffect(() => {
    //     setLoading(true);
    //     if (licenseCount) {
    //         setProductCode("INVCCCP");
    //         // setLicenseCount(Number(props.match.params.defaultQty))
    //         const expireDate = new Date(licenseCount.expireAt).setHours(0, 0, 0, 0);
    //         const currentDate = new Date().setHours(0, 0, 0, 0);
    //         const difference = expireDate - currentDate;
    //         const differenceInDays = Math.floor(difference / (1000 * 3600 * 24));
    //         setLoading(false);
    //         setDays(differenceInDays);
    //     } else {
    //         // setProductCode(props.match.params && props.match.params.productCode ? props.match.params.productCode : "");
    //         setProductCode(productPathCode);
    //         setLoading(false);
    //         setDays(365);
    //     }
    // }, [licenseCount]);

    // useEffect(() => {
    // getPayLoad();
    // }, []);

    // let qty = 5
    // useEffect(() => {
    //     if (username && subdomain) {
    //         let query = `?username=${username}&subdomain=${subdomain}`
    //         setLoading(true);
    //         getUnlicencedData(query).then((res) => {
    //             if (res.status) {
    //                 setClinicBody(res?.data)
    //                 console.log('licenced data------', res?.data);
    //                 qty = productPathCode === "INVCFREE" ? 5 : res?.licenses?.noOfLicense ? res?.licenses?.noOfLicense : 5;
    //                 setLicenseCount(qty)
    //             } else {
    //                 setClinicBody({});
    //             }
    //             setLoading(false);
    //         }).catch((err) => {
    //             setLoading(false);
    //             console.log('err--------', err);
    //             setClinicBody({});
    //         })
    //     }
    // }, []);



    useEffect(() => {
        // props.match.params.productCode
        if (ProductLicenses[productPathCode]) {
            setProduct(ProductLicenses[productPathCode]);
        }
    }, []);

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    useEffect(() => {
        getCouponCode();
    }, [clinicBody]);

    const getCouponCode = async () => {
        if (clinicBody && clinicBody?.referral) {
            let query = `?referrerId=${clinicBody?.referral}&productCode=INCLINIC`;
            try {
                setLoading(true);
                const couponRes = await getCouponDetails(query);

                if (couponRes?.status) {
                    setCouponCode(couponRes?.coupon);
                    setOpenCoupon(true);
                    handleCouponApply("", couponRes?.coupon);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            } catch (err) {
                // toast.error(err?.response?.data?.error, {
                //   position: toast.POSITION.TOP_RIGHT,
                // });

                setCouponCode("");
                setCouponError(err?.response?.data?.error);
                setLoading(false);
            }
        }
    };



    const placeOrder = () => {
        if (licenseCount <= 0) {
            toast.error("Users count should not be less than 1", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        if (licenseCount > 16) {
            toast.error("Users count should not be greater than 16", {
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {
            if (productPathCode === "INVCFREE" || estimatedTotal === 0) {
                let body = {
                    username: clinicBody?.email,
                    subdomain: clinicBody?.subdomain,
                };
                setLoading(true);
                createFreeOrder(body)
                    .then((res) => {
                        if (res.status) {
                            toast.success("Please visit your subdomain to login. Subdomain url has been shared by sms.", {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            window.open(`https://${clinicBody?.subdomain}${process.env.REACT_APP_domainURL}`, "_self");
                            setLoading(false);
                            // history.push("/");
                        }
                        // history.push("/");
                    })
                    .catch((err) => {
                        toast.error(err?.response?.data?.err, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoading(false);
                    });
            } else {
                setLoading(true);
                //     productCode: productPathCode,
                //     qty: licenseCount,
                //     appId: "Inclinic",
                //     phone: payload?.phone,
                //     subdomain: payload?.subdomain,
                //     couponCode: couponCode && couponCode !== "" ? couponCode : undefined,
                //     userId: payload && payload.userId ? payload.userId : undefined,
                // });

                let body = {
                    productCode: productPathCode,
                    qty: licenseCount,
                    appId: "Inclinic",
                    username: clinicBody?.email ? clinicBody?.email : payload.email,
                    // userId: payload?.userId ? payload?.userId : null,
                    subdomain: clinicBody?.subdomain ? clinicBody?.subdomain : payload?.subdomain,
                    // phone: payload.phone,
                    // subdomain: payload.subdomain,
                    couponCode: couponCode && couponCode !== "" ? couponCode : undefined,
                };
                createOrder(body)
                    .then((res) => {
                        setOrder(res);
                    })
                    .catch((err) => {
                        toast.error(err?.response?.data?.err, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoading(false);
                    });
            }
        }
    };

    const handleCouponAdd = () => {
        setOpenCoupon(true);
        setCouponError("");
    };
    const handleCouponClose = () => {
        setOpenCoupon(false);
    };

    const handleCouponApply = (e, _couponCode = null) => {
        setCouponError("");
        let _cc = _couponCode === null ? couponCode : _couponCode;
        if (_cc && _cc !== "") {
            applyCoupon(_cc, productPathCode)
                .then((res) => {
                    if (res && res.status) {
                        setDiscount(res.data);
                    } else {
                        setDiscount(null);
                        setCouponError("Invalid Coupon");
                    }
                })
                .catch((err) => {
                    console.log("err ==== ", err);
                    setDiscount(null);
                    setCouponError("Invalid Coupon");
                });
        } else {
            setCouponError("Please enter the Coupon");
        }
    };

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    let tax = product ? (product.Price * 12 * licenseCount * product.Tax) / 100 : 0;
    let dis = 0;
    if (discount && discount > 0) {
        dis = product ? (product.Price * 12 * licenseCount * discount) / 100 : 0;
        tax = product ? ((product.Price * 12 * licenseCount - dis) * product.Tax) / 100 : 0;
    }

    let estimatedTotal = product?.Price * licenseCount * 12 - dis + tax;

    useEffect(() => {
        const initatePayment = async (_order) => {
            const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            if (!res) {
                alert("Razorpay SDK failed to load. Are you online?");
                return;
            }

            const options = {
                key: process.env.REACT_APP_rzr_live_key, //(process.env.REACT_APP_payments.status) ? process.env.REACT_APP_payments.live : process.env.REACT_APP_payments.test, // Enter the Key ID generated from the Dashboard
                amount: _order.amount.toString(),
                currency: _order.currency,
                name: "inClinic License",
                description: product.Descirption,
                // image: { logo },
                order_id: _order.id,
                handler: async function (response) {
                    // const data = {
                    //     orderCreationId: _order.id,
                    //     razorpayPaymentId: response.razorpay_payment_id,
                    //     razorpayOrderId: response.razorpay_order_id,
                    //     razorpaySignature: response.razorpay_signature,
                    // };
                    await capturePayment({ paymentId: response.razorpay_payment_id, currency: _order.currency, amount: _order.amount })
                        .then((res) => {
                            // console.log("response from paymentcapture api", res);
                        })
                        .catch((err) => {
                            console.log("error from paymentcapture api", err);
                        });

                    toast.success("Payment Successful ! ", {
                        position: toast.POSITION.TOP_RIGHT,
                    });


                    // let clinic_temp = clinicBody;
                    // clinic_temp.doctorsCount = licenseCount;

                    // if (clinic_temp) {
                    //     setClinicBody(clinic_temp);
                    // }

                    // history.push("/confirm-clinic")

                    history.push(`/confirm-clinic?email=${clinicBody?.email}`);
                    // createUser(clinicBody).then(res => {
                    //     setLoading(false);
                    //     console.log("res in create user=============", res);
                    //     if (res.status) {
                    //         toast.success("Clinic created successfully", {
                    //             position: toast.POSITION.TOP_RIGHT
                    //         })

                    //         let pmtObj={domain_name:clinicBody.subdomain,phone_number:res.data.phone,userId:res.data.userId,paymentId:data.razorpayPaymentId,paymentRes:data,paymentRef:res.data.payment_ref}

                    //         return pmtObj

                    //         //console.log("payment obj1",paymentObj)
                    //         //history.push('/admin-users/clinic');
                    //     }
                    // }).then((pmtObj)=>{

                    //     console.log("pmtobj",pmtObj)

                    //     updatePaymentStatus(pmtObj).then((res)=>{

                    //         setLoading(false)
                    //         console.log("response from paymentUpdate",res)

                    //         let clinicUrl= `https://${clinicBody.subdomain}.inclinic.vc`

                    //         //open new url

                    //         window.open(clinicUrl,"_self")

                    //     }).catch((err)=>{
                    //         console.log("Error",err)
                    //     })

                    // })

                    // .catch(err => {
                    //     setLoading(false);
                    //     console.log("error in create user=======", err.response);
                    //     let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_crt_clinic;

                    //     toast.error(msg, {
                    //         position: toast.POSITION.TOP_RIGHT
                    //     })
                    //     setErrorMsg(msg)
                    // });

                    // setLoading(true);

                    // history.push('/payment-success');

                    //history.push('/');

                    // const result = await axios.post("http://localhost:5000/payment/success", data);

                    // alert(result.data.msg);
                },
                prefill: {
                    name: "inVC",
                },
                theme: {
                    color: "#008abc",
                },
            };

            const paymentObject = new window.Razorpay(options);

            paymentObject.on("payment.failed", (response) => {
                history.push(`/payment-failure?redirect=${window.location.pathname}`);
            });
            paymentObject.open();
        };

        if (order) {
            initatePayment(order);
        }
    }, [order]);

    useEffect(() => {
        let curr = 'inr'
        getAxios(curr).then((res) => {
            let result = res.data[curr].usd
            setMaxCurr(500000*result)
        }).catch((err) => console.log(err))
    }, [])


    useEffect(() => {
        if (product && product.Price && ((product.Price * licenseCount * 12) - dis + tax) > maxCurr) {
                toast.warn("Payment limit is Exceed", {
                    position: toast.POSITION.TOP_RIGHT
                });
                let lc = Math.floor((maxCurr + dis) / (12 * product.Price*1.18))
                setLicenseCount(lc);
            }
    }, [licenseCount])

    return (
        <>
            <div className="placeOrderCntrn">
                {/* {loading && <Loading />} */}
                <div className="poHeader">
                    <div className="poLogoBox">
                        <img src={process.env.REACT_APP_logo} alt="invc logo" className="outLogoSm" onClick={() => history.push("/")} />
                    </div>
                </div>
                <div className="poBdy">
                    {/* <InnerLoader /> */}

                    <div className="poCol pdRes016">
                        <h1 className="headingLg">Place your order</h1>
                        {props.userPayload && (
                            <div className="brdrCard mrgnBtm12">
                                <h3>Your Details</h3>
                                <ul className="poListGroup">
                                    <li className="plListItem">
                                        <span className="poDTxt">{props.userPayload["custom:fname"]}</span>
                                    </li>
                                    <li className="plListItem">
                                        <span className="poDTxt">{props.userPayload["custom:phone"]}</span>
                                    </li>
                                    <li className="plListItem">
                                        <span className="poDTxt">{props.userPayload["email"]}</span>
                                    </li>
                                </ul>
                            </div>
                        )}
                        <div className="brdrCard mrgnBtm12 cardBg">
                            <h3>Order Summary</h3>
                            <ul className="poListGroup">
                                {product && (
                                    <li className="plListItem">
                                        <div className="poBox">
                                            <div className="pdFlexMinBox">
                                                <span className="txtLicName">{product.Product}</span>
                                            </div>
                                            <div className="poFlexAutoBox">
                                                <span className="txtNumUser">No of Users:</span>
                                                <input
                                                    disabled={true}
                                                    type="text"
                                                    value={licenseCount}
                                                    min="84"
                                                    max="50000"
                                                    onChange={(e) => {
                                                        if (productPathCode !== "INVCFREE" || estimatedTotal === 0) {
                                                            setLicenseCount(Number(e.target.value));
                                                        }
                                                    }}
                                                    className="countInput"
                                                />

                                                {productPathCode === "INVCFREE" || estimatedTotal === 0 ? null : (
                                                    <>
                                                        <button
                                                            disabled={licenseCount < 2}
                                                            className="btnMinus"
                                                            onClick={() => {
                                                                setLicenseCount(licenseCount - 1);
                                                            }}
                                                        />

                                                        <button
                                                            className="btnPlus"
                                                            onClick={() => {
                                                                setLicenseCount(licenseCount + 1);
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {/* <span className="poDTxt">inVC Software Licence</span> */}
                                    </li>
                                )}
                                <li className="plListItem">{product && <span className="poDTxt">{product.Descirption}</span>}</li>
                            </ul>
                            {product && (
                                <div className="poCol">
                                    <ul className="poListGroup">
                                        <li className="plListItem spaceBtvn">
                                            <span className="poLTxt">Licence Cost:</span>
                                            <span className="poDTxt">{formatter.format(product.Price * licenseCount * 12)}</span>
                                        </li>
                                        <li className="plListItem spaceBtvn">
                                            <span className="poLTxt">Taxes (GST {product.Tax}%):</span>
                                            <span className="poDTxt">{formatter.format(tax)}</span>
                                        </li>
                                        <li className="plListItem spaceBtvn sumBrdrTop">
                                            <span className="poDTxt">Order Total:</span>
                                            <span className="poDTxt">{formatter.format(product.Price * licenseCount * 12 + tax)}</span>
                                        </li>
                                        {discount && discount > 0 && (
                                            <Fragment>
                                                <li className="plListItem spaceBtvn">
                                                    <span className="poLTxt successTxt">Discount :</span>
                                                    <span className="poDTxt successTxt">- {formatter.format(dis)}</span>
                                                </li>
                                                <li className="plListItem spaceBtvn">
                                                    <span className="poDTxt">Estimated Total:</span>
                                                    <span className="poDTxt">
                                                        {formatter.format(product.Price * licenseCount * 12 - dis + tax)}
                                                    </span>
                                                </li>
                                            </Fragment>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>

                        {productPathCode !== "INVCFREE" && (
                            <>
                                {discount && discount > 0 ?

                                    <div className="brdrCard mrgnBtm12 cardBg">
                                        <div className="flexRow">
                                            <div className="flexAutoRow mrgRight alignCenter">
                                                <div className="imgCnt">
                                                    <img src="/images/icons/coupons.png" alt="coupon" className="invertPrimary" />
                                                </div>
                                            </div>
                                            <div className="flexMinWidthCol">
                                                <div className="flexColContainer">
                                                    <span>{`CouponID-${couponCode}`}</span>
                                                    <br />
                                                    <span className="font12Txt lightTxt successTxt">Coupon applied</span>
                                                </div>
                                            </div>
                                            {/* <div className="flexAutoRow">
                                           <div className="customIconBtn ">
                                               <img
                                                   src="/images/icons/blue-close-icon.png"
                                                   alt="closeicon"
                                                   onClick={handleCancleCoupon}
                                               />
                                           </div>
                                       </div> */}
                                        </div>
                                    </div>
                                    :
                                    <>
                                        {openCoupon ?
                                            <div className="flexCol couponBox">
                                                <button className="btnTRAbslt" onClick={handleCouponClose} />
                                                <span className="poDTxt mrgnBtm12">Add coupon number</span>
                                                <input
                                                    type="text"
                                                    placeholder="Add Coupon number"
                                                    className="countInput fullWithInput mrgnBtm12"
                                                    value={couponCode}
                                                    onChange={(e) => setCouponCode(e.target.value.trim().toUpperCase())}
                                                />
                                                {couponError && couponError !== "" && (
                                                    <span className="poDTxt mrgnBtm12 dangerTxt">{couponError}</span>
                                                )}

                                                <div className="flexRow jcFE">
                                                    <Controls.Button
                                                        variant="contained"
                                                        size="small"
                                                        color="primary"
                                                        text="Add"
                                                        className="whiteTxt"
                                                        onClick={handleCouponApply}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <div className="flexRow mrgnBtm12 jcFE">
                                                <div className="inlineFlex">
                                                    <Controls.Button
                                                        variant="outlined"
                                                        size="small"
                                                        color="primary"
                                                        text="Do you have a Coupon?"
                                                        onClick={handleCouponAdd}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        )}


                        {!loading && (
                            <div className="poRow mrgnBtm24">
                                <div className="btmActFlexEnd">
                                    <Controls.Button
                                        size="large"
                                        color="primary"
                                        text="Place Your Order Now!"
                                        className="whiteTxt"
                                        onClick={() => placeOrder()}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="poRow jstyCenter">
                            <small className="hintTxt">
                                When you place an order, we will send you an e-mail message acknowledging a receipt of your order.
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
        </>
    );
}

export default PlaceYourOrder;
